import axios from '@fs/zion-axios'
import { useFeatureFlag } from '@fs/zion-flags'
import useFetchData from './useFetchData'
import useStateManager from './useStateManager'
import getIdentBaseUrl from '../utils/getIdentBaseUrl'

const fetchJurisdictions = async (isOn = false) => {
  if (!isOn) {
    return []
  }
  const { data } = await axios.get(`${getIdentBaseUrl()}/service/ident/authn/accounts/CURRENT/jurisdictions`)
  return data?.jurisdictions ?? []
}

const updateJurisdictions = (jurisdictions) =>
  Promise.all(
    jurisdictions.map(({ jurisdiction, doesApply }) =>
      axios.post(`${getIdentBaseUrl()}/service/ident/authn/accounts/CURRENT/jurisdictions`, {
        jurisdiction,
        doesApply,
      })
    )
  )

export default function useJurisdictions() {
  const { isOn } = useFeatureFlag('identity_settingsReact_ruCitizen')
  const { data: remoteJurisdictions, loading: jurisdictionsLoading } = useFetchData(fetchJurisdictions, {
    initialData: [],
    requestFnArg: isOn,
  })
  const { state: localJurisdictions, handleChangeState: handleChangeJurisdictions } =
    useStateManager(updateJurisdictions)
  const jurisdictions = localJurisdictions ?? remoteJurisdictions
  return { jurisdictions, jurisdictionsLoading, handleChangeJurisdictions }
}
